import { render, staticRenderFns } from "./ReceiptCancel.vue?vue&type=template&id=6e53a7ec&"
import script from "./ReceiptCancel.vue?vue&type=script&lang=js&"
export * from "./ReceiptCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e53a7ec')) {
      api.createRecord('6e53a7ec', component.options)
    } else {
      api.reload('6e53a7ec', component.options)
    }
    module.hot.accept("./ReceiptCancel.vue?vue&type=template&id=6e53a7ec&", function () {
      api.rerender('6e53a7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/modals/ReceiptCancel.vue"
export default component.exports